/**
 * @generated SignedSource<<36f2d76c8817a300d109b2c7220a850d>>
 * @relayHash 1da0842744f30cfa8a4eb4fde9c6039f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID df48bbaa59ae6c756e138e6315414784292ef193d9bcc71c69a42d7194a50065

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { ui_jiraCalendarQuery } from './ui_jiraCalendarQuery.graphql';

const node: PreloadableConcreteRequest<ui_jiraCalendarQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "df48bbaa59ae6c756e138e6315414784292ef193d9bcc71c69a42d7194a50065",
    "metadata": {},
    "name": "ui_jiraCalendarQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
